export const BEGIN_TIME_LIMIT = '6:00 AM';
export const END_TIME_LIMIT = '5:45 AM';
export const MILLIS_TO_REFRESH =
  Number(process.env.REACT_APP_REFRESH_MINUTES || 9) * 60 * 1000;
export const MILLIS_TO_EXPIRE =
  Number(process.env.REACT_APP_EXPIRE_MINUTES || 10) * 60 * 1000;
